import Icon from '@atoms/Icon/Icon';
import { IconName } from '@models/IIcon';
import IconSizeEnum from '@models/enums/IconSizeEnum';

interface Props {
  readonly title: string;
  readonly href: string;
  readonly target: string;
  readonly icon?: IconName;
  readonly isTabbingDisabled?: boolean;
}

const MobileAccountLink = ({
  title,
  href,
  target = '_self',
  icon = 'account',
  isTabbingDisabled,
}: Props) => (
  <a
    {...(isTabbingDisabled ? { tabIndex: -1 } : {})}
    href={href}
    className="h5 mb-8 flex w-full cursor-pointer flex-row items-center gap-x-4 pr-5 pl-5 text-black-100"
    target={target}
  >
    <div className="flex items-center justify-center">
      <Icon name={icon} size={IconSizeEnum.lg} className="mr-2 shrink-0" />
      <span className="text-left">{title}</span>
    </div>

    <div className="ml-auto flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-yellow">
      <Icon name="east" size={IconSizeEnum.sm} />
    </div>
  </a>
);

export default MobileAccountLink;
